import { render, staticRenderFns } from "./editPassWord.vue?vue&type=template&id=fa3163f2&scoped=true&"
import script from "./editPassWord.vue?vue&type=script&lang=js&"
export * from "./editPassWord.vue?vue&type=script&lang=js&"
import style0 from "./editPassWord.vue?vue&type=style&index=0&id=fa3163f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3163f2",
  null
  
)

export default component.exports